import Games from "app/Games/config";
const serviceProviders = {
    Games,
};

export default serviceProviders;
